import { render, staticRenderFns } from "./Halloween.vue?vue&type=template&id=20252503&scoped=true"
import script from "./Halloween.vue?vue&type=script&lang=js"
export * from "./Halloween.vue?vue&type=script&lang=js"
import style0 from "./Halloween.vue?vue&type=style&index=0&id=20252503&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20252503",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20252503')) {
      api.createRecord('20252503', component.options)
    } else {
      api.reload('20252503', component.options)
    }
    module.hot.accept("./Halloween.vue?vue&type=template&id=20252503&scoped=true", function () {
      api.rerender('20252503', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Halloween.vue"
export default component.exports